import React from 'react';
import { gql } from '@apollo/client';
import { getStyles } from '../utils/get-styles/getStyles.js';
import { useBlocksTheme } from '../components/WordPressBlocksProvider.js';
import { WordPressBlocksViewer, } from '../components/WordPressBlocksViewer.js';
export function CoreColumn(props) {
    const theme = useBlocksTheme();
    const style = getStyles(theme, Object.assign({}, props));
    const { attributes, innerBlocks } = props;
    return (React.createElement("div", { style: style, className: attributes === null || attributes === void 0 ? void 0 : attributes.cssClassName },
        React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] })));
}
CoreColumn.fragments = {
    key: `CoreColumnBlockFragment`,
    entry: gql `
    fragment CoreColumnBlockFragment on CoreColumn {
      attributes {
        anchor
        borderColor
        backgroundColor
        cssClassName
        fontSize
        fontFamily
        gradient
        layout
        style
        textColor
        verticalAlignment
        width
      }
    }
  `,
};
CoreColumn.config = {
    name: 'CoreColumn',
};
CoreColumn.displayName = 'CoreColumn';
